import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';

function History({ history: { title, intro, milestones } }) {
  return (
    <Container fluid className="bg-darker pl-md-6 .bg-shapes-clouds-dark-v4 overflow-hidden px-0 py-6">
      <Container className="py-6">
        <h2 className="text-white">{title}</h2>
        <Row noGutters className="py-4">
          <Col xs={12} lg={11} className="row history-ck-editor-text text-gray-450">
            {intro.map((item) => (
              <PortableText key={item.id} value={item.description} />
            ))}
          </Col>
        </Row>
      </Container>
      <Container fluid className="container-scroll mb-md-6">
        <Row className="scrollbar-secondary scroll-snap-type-x-mandatory flex-nowrap overflow-scroll pb-6 text-white">
          {milestones.map((milestone) => (
            <Col xs={8} xl={6} key={milestone.id} className="scroll-snap-align-start">
              <GatsbyImage
                alt={milestone.image?.alt ?? ''}
                image={milestone.image?.image?.asset?.gatsbyImageData ?? imgFallback}
                className="mb-2 shadow"
              />
              <span className="text-size-xs text-gray-450">{milestone.date}</span>
              <Col sm={10} className="h5 font-weight-bold px-0 pt-2 text-white">
                {milestone.description}
              </Col>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default History;
